// GetTopBanner returns current campaign for top banner
// or the list of campaign periods that'd be active in future
export const CampaignsService_GetTopBannerLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_GetTopBanner);
CampaignsService_GetTopBannerLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetTopBanner" as const;

// GetAppInstallTeaser returns teaser to promote app installation
export const CampaignsService_GetAppInstallTeaserLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_GetAppInstallTeaser);
CampaignsService_GetAppInstallTeaserLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetAppInstallTeaser" as const;

// GetcampaignsConditions returns the campaigns condition of any active campaign
export const CampaignsService_GetCampaignsConditionsLazy = () =>
  import("./service.grpc").then(
    (m) => m.CampaignsService_GetCampaignsConditions
  );
CampaignsService_GetCampaignsConditionsLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetCampaignsConditions" as const;

// ReportCampaignPurchase marks the current device as having purchased for the currently active campaign.
//
// If there is no active campaign, the endpoint will return a PreconditionFailure error.
export const CampaignsService_ReportCampaignPurchaseLazy = () =>
  import("./service.grpc").then(
    (m) => m.CampaignsService_ReportCampaignPurchase
  );
CampaignsService_ReportCampaignPurchaseLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/ReportCampaignPurchase" as const;

// GetSplashScreen returns a video url that is shown on the splash screen of the app (during the app startup).
//
// The video is for special campaign-related content and is only shown during a specific time window.
export const CampaignsService_GetSplashScreenLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_GetSplashScreen);
CampaignsService_GetSplashScreenLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetSplashScreen" as const;

// Returns available discounts to the user.
//
// This can be a running public reduction campaing (PX) or user-bound
// personal discounts.
export const CampaignsService_GetDiscountsLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_GetDiscounts);
CampaignsService_GetDiscountsLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetDiscounts" as const;

// Deprecated - Returns winter sale banner.
export const CampaignsService_GetWinterSaleBannerLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_GetWinterSaleBanner);
CampaignsService_GetWinterSaleBannerLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/GetWinterSaleBanner" as const;

// Submits the CRM event token to the backend
export const CampaignsService_SubmitCRMEventTokenLazy = () =>
  import("./service.grpc").then((m) => m.CampaignsService_SubmitCRMEventToken);
CampaignsService_SubmitCRMEventTokenLazy.method =
  "aysa_api.services.campaigns.v1.CampaignsService/SubmitCRMEventToken" as const;
